(function () {
  function getRealCards(carousel) {
    return Array.from(
      carousel.querySelectorAll('.jdgm-card.jdgm-carousel-item:not(.jdgm-clone-before):not(.jdgm-clone-after)')
    );
  }

  function getActiveIndex(carousel) {
    const activeCard = carousel.querySelector('.jdgm-card.jdgm-carousel-item.active:not(.jdgm-clone-before):not(.jdgm-clone-after)');
    if (!activeCard) return 0;
    const activeIndex = parseInt(activeCard.getAttribute('data-card-index'), 10);
    return isNaN(activeIndex) ? 0 : activeIndex;
  }

  function goToIndexCards(blockId, currentIndex, targetIndex) {
    if (currentIndex === targetIndex) return;
    const difference = targetIndex - currentIndex;
    const navigationFunction = difference > 0 ? window.jdgmNextCard : window.jdgmPreviousCard;
    const steps = Math.abs(difference);
    for (let stepCount = 0; stepCount < steps; stepCount++) {
      try { navigationFunction(blockId); } catch (error) {}
    }
  }

  function getSlidesCount(carousel) {
    const slidesCountRaw = getComputedStyle(carousel).getPropertyValue('--slides-count').trim();
    const slidesCount = parseInt(slidesCountRaw, 10);
    return isNaN(slidesCount) || slidesCount < 1 ? 1 : slidesCount;
  }

  function buildCardsDots(carousel) {
    if (carousel.dataset.ecDotsInit === '1') return;
    const blockId = carousel.getAttribute('data-jdgm-block-id');
    if (!blockId) return;
    const cards = getRealCards(carousel);
    if (cards.length <= 1) return;

    const dotsCount = Math.min(4, cards.length);

    const dotsWrapper = document.createElement('div');
    dotsWrapper.className = 'ec-carrossel-dots ec-jdgm-carrossel-dots';
    for (let dotIndex = 0; dotIndex < dotsCount; dotIndex++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ec-carrossel-dot';
      dot.setAttribute('aria-label', 'Ir para página ' + (dotIndex + 1));
      dot.addEventListener('click', function () {
        if (window.innerWidth <= 500) {
          const scrollContent = carousel.querySelector('.jdgm-content');
          const realCards = getRealCards(carousel);
          if (scrollContent && realCards[dotIndex]) {
            scrollContent.scrollTo({ left: realCards[dotIndex].offsetLeft - scrollContent.offsetLeft, behavior: 'smooth' });
          }
        } else {
          goToIndexCards(blockId, getActiveIndex(carousel), dotIndex);
        }
      });
      dotsWrapper.appendChild(dot);
    }
    carousel.appendChild(dotsWrapper);
    appendReclameAqui(carousel);
    carousel.dataset.ecDotsInit = '1';
    updateCardsDots(carousel);

    const cardsWrapper = carousel.querySelector('.jdgm-cards-wrapper');
    if (cardsWrapper) {
      const cardsWrapperObserver = new MutationObserver(() => updateCardsDots(carousel));
      cardsWrapperObserver.observe(cardsWrapper, { subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    }

    const scrollContent = carousel.querySelector('.jdgm-content');
    if (scrollContent) {
      scrollContent.addEventListener('scroll', function () {
        if (window.innerWidth > 500) return;
        const realCards = getRealCards(carousel);
        if (!realCards.length) return;
        const cardWidth = realCards[0].getBoundingClientRect().width + 12;
        const activeIndex = Math.min(Math.round(scrollContent.scrollLeft / cardWidth), dotsCount - 1);
        const dots = carousel.querySelectorAll('.ec-jdgm-carrossel-dots .ec-carrossel-dot');
        dots.forEach((dot, dotIndex) => dot.classList.toggle('active', dotIndex === activeIndex));
      });
    }
  }

  function updateCardsDots(carousel) {
    const dots = carousel.querySelectorAll('.ec-jdgm-carrossel-dots .ec-carrossel-dot');
    if (!dots.length) return;
    const activeIndex = Math.min(getActiveIndex(carousel), dots.length - 1);
    dots.forEach((dot, dotIndex) => dot.classList.toggle('active', dotIndex === activeIndex));
  }

  function getClassicItems(carousel) {
    return Array.from(carousel.querySelectorAll('.jdgm-carousel__item-wrapper > .jdgm-carousel-item'));
  }

  function getClassicTransformIndex(carousel) {
    const itemWrapper = carousel.querySelector('.jdgm-carousel__item-wrapper');
    const items = getClassicItems(carousel);
    if (!itemWrapper || !items.length) return 0;
    const transformValue = itemWrapper.style.transform || '';
    const translateMatch = transformValue.match(/translate3d\(\s*(-?\d+\.?\d*)px/);
    if (!translateMatch) return 0;
    const translateX = Math.abs(parseFloat(translateMatch[1]));
    const itemWidth = items[0].getBoundingClientRect().width;
    if (!itemWidth) return 0;
    return Math.round(translateX / itemWidth);
  }

  function buildClassicDots(carousel) {
    if (carousel.dataset.ecDotsInit === '1') return;
    const items = getClassicItems(carousel);
    if (items.length <= 1) return;
    const leftArrow = carousel.querySelector('.jdgm-carousel__left-arrow');
    const rightArrow = carousel.querySelector('.jdgm-carousel__right-arrow');
    if (!leftArrow || !rightArrow) return;

    const dotsWrapper = document.createElement('div');
    dotsWrapper.className = 'ec-carrossel-dots ec-jdgm-carrossel-dots';
    items.forEach((_, targetIndex) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'ec-carrossel-dot';
      dot.setAttribute('aria-label', 'Ir para review ' + (targetIndex + 1));
      dot.addEventListener('click', function () {
        const currentIndex = getClassicTransformIndex(carousel);
        const difference = targetIndex - currentIndex;
        const arrow = difference > 0 ? rightArrow : leftArrow;
        const steps = Math.abs(difference);
        for (let stepCount = 0; stepCount < steps; stepCount++) {
          arrow.click();
        }
      });
      dotsWrapper.appendChild(dot);
    });
    carousel.appendChild(dotsWrapper);
    carousel.dataset.ecDotsInit = '1';
    updateClassicDots(carousel);

    const itemWrapper = carousel.querySelector('.jdgm-carousel__item-wrapper');
    if (itemWrapper) {
      const itemWrapperObserver = new MutationObserver(() => updateClassicDots(carousel));
      itemWrapperObserver.observe(itemWrapper, { attributes: true, attributeFilter: ['style'] });
    }
  }

  function updateClassicDots(carousel) {
    const dots = carousel.querySelectorAll('.ec-jdgm-carrossel-dots .ec-carrossel-dot');
    if (!dots.length) return;
    const activeIndex = getClassicTransformIndex(carousel);
    dots.forEach((dot, dotIndex) => dot.classList.toggle('active', dotIndex === activeIndex));
  }

  function buildDateMap() {
    const byReviewId = {};
    const byReviewerName = {};
    document.querySelectorAll('.jdgm-carousel .jdgm-carousel-item[data-review-id]').forEach((item) => {
      const reviewId = item.getAttribute('data-review-id');
      const timestampElement = item.querySelector('.jdgm-carousel-item__timestamp');
      const reviewerNameElement = item.querySelector('.jdgm-carousel-item__reviewer-name');
      if (!timestampElement) return;
      const rawTimestamp = timestampElement.getAttribute('data-time') || timestampElement.textContent.trim();
      const formattedDate = formatDate(rawTimestamp);
      if (reviewId) byReviewId[reviewId] = formattedDate;
      if (reviewerNameElement) {
        const reviewerName = reviewerNameElement.textContent.trim();
        if (reviewerName && !byReviewerName[reviewerName]) byReviewerName[reviewerName] = formattedDate;
      }
    });
    return { byReviewId, byReviewerName };
  }

  function formatDate(rawDate) {
    if (!rawDate) return '';
    const dateMatch = rawDate.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (dateMatch) return dateMatch[2] + '/' + dateMatch[1] + '/' + dateMatch[3];
    return rawDate;
  }

  function injectDatesIntoCards() {
    const { byReviewId, byReviewerName } = buildDateMap();
    if (!Object.keys(byReviewId).length && !Object.keys(byReviewerName).length) return;
    document.querySelectorAll('.jdgm-cards-carousel .jdgm-card.jdgm-media-card[data-review-id]').forEach((card) => {
      if (card.dataset.ecDateInjected === '1') return;
      const reviewerInfo = card.querySelector('.jdgm-reviewer-info');
      if (!reviewerInfo) return;
      const reviewId = card.getAttribute('data-review-id');
      const reviewerNameElement = reviewerInfo.querySelector('.jdgm-reviewer-name');
      const reviewerName = reviewerNameElement ? reviewerNameElement.textContent.trim() : '';
      const formattedDate = byReviewId[reviewId] || byReviewerName[reviewerName] || '';
      if (!formattedDate) return;
      const dateSpan = document.createElement('span');
      dateSpan.className = 'jdgm-reviewer-date ec-injected-date';
      dateSpan.textContent = formattedDate;
      reviewerInfo.appendChild(dateSpan);
      card.dataset.ecDateInjected = '1';
    });
  }

  function getAssetUrl(filename) {
    const scripts = document.querySelectorAll('script[src*="ec-jdgm-carousel-dots"]');
    if (scripts.length) {
      const scriptSrc = scripts[0].getAttribute('src');
      return scriptSrc.replace(/ec-jdgm-carousel-dots\.js.*$/, filename);
    }
    return '/cdn/shop/files/' + filename;
  }

  function appendReclameAqui(carousel) {
    if (carousel.querySelector(':scope > .ec-jdgm-reclame-aqui')) return;
    const reclameWrapper = document.createElement('div');
    reclameWrapper.className = 'ec-jdgm-reclame-aqui';
    const label = document.createElement('span');
    label.className = 'ec-jdgm-reclame-aqui__label';
    label.textContent = 'Avaliações confiáveis do';
    const logoImage = document.createElement('img');
    logoImage.src = getAssetUrl('ec-reclame-aqui.svg');
    logoImage.alt = 'Reclame Aqui';
    logoImage.className = 'ec-jdgm-reclame-aqui__logo';
    reclameWrapper.appendChild(label);
    reclameWrapper.appendChild(logoImage);
    carousel.appendChild(reclameWrapper);
  }

  function resetMobileScroll() {
    if (window.innerWidth > 500) return;
    document.querySelectorAll('.jdgm-cards-carousel .jdgm-content').forEach((scrollContent) => {
      scrollContent.scrollLeft = 0;
      scrollContent.style.touchAction = 'pan-x';
      scrollContent.style.webkitOverflowScrolling = 'touch';
      ['touchstart', 'touchmove', 'touchend', 'pointerdown', 'pointermove', 'pointerup'].forEach((eventName) => {
        scrollContent.addEventListener(eventName, function (event) { event.stopPropagation(); }, { capture: true, passive: true });
      });
    });
  }

  function init() {
    setTimeout(injectDatesIntoCards, 300);
    setTimeout(injectDatesIntoCards, 1000);
    setTimeout(injectDatesIntoCards, 2500);
    setTimeout(resetMobileScroll, 300);
    setTimeout(resetMobileScroll, 1000);

    document.querySelectorAll('.jdgm-cards-carousel[data-jdgm-block-id]').forEach((carousel) => {
      const tryBuild = () => {
        if (getRealCards(carousel).length > 0) buildCardsDots(carousel);
        else setTimeout(tryBuild, 200);
      };
      tryBuild();
    });

    document.querySelectorAll('.jdgm-carousel').forEach((carousel) => {
      const tryBuild = () => {
        if (getClassicItems(carousel).length > 0 && carousel.querySelector('.jdgm-carousel__left-arrow')) buildClassicDots(carousel);
        else setTimeout(tryBuild, 200);
      };
      tryBuild();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
})();
